const CARDS = [
  {
    green: false,
    lbl: 'UPI anomaly monitoring',
    desc: 'live pattern detection',
    icon: (
      <svg viewBox="0 0 56 56">
        <text x="28" y="33" textAnchor="middle" fontFamily="Inter" fontSize="18" fontWeight="900" letterSpacing="-0.04em" fill="currentColor">UPI</text>
        <line x1="20" y1="40" x2="36" y2="40" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    green: true,
    lbl: 'PMLA filings (CTR/STR)',
    desc: 'regulator-shaped exports',
    icon: (
      <svg viewBox="0 0 56 56" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 10h20l8 8v28a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2z" />
        <path d="M36 10v8h8" />
        <line x1="20" y1="26" x2="36" y2="26" />
        <line x1="20" y1="32" x2="36" y2="32" />
        <line x1="20" y1="38" x2="30" y2="38" />
      </svg>
    ),
  },
  {
    green: false,
    lbl: 'Indian sanctions feeds',
    desc: 'auto-sync from central lists',
    icon: (
      <svg viewBox="0 0 56 56" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M28 8l16 6v12c0 11-7 19-16 22-9-3-16-11-16-22V14l16-6z" />
        <path d="M20 28l6 6 12-12" />
      </svg>
    ),
  },
  {
    green: true,
    lbl: 'RBI posture defaults',
    desc: 'policy preset on day one',
    icon: (
      <svg viewBox="0 0 56 56" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 22 L28 10 L48 22" />
        <line x1="6" y1="22" x2="50" y2="22" />
        <line x1="12" y1="22" x2="12" y2="40" />
        <line x1="20" y1="22" x2="20" y2="40" />
        <line x1="28" y1="22" x2="28" y2="40" />
        <line x1="36" y1="22" x2="36" y2="40" />
        <line x1="44" y1="22" x2="44" y2="40" />
        <line x1="6" y1="44" x2="50" y2="44" />
      </svg>
    ),
  },
  {
    green: false,
    lbl: 'Native ISO 20022',
    desc: 'pacs.008 and pacs.002 built in',
    icon: (
      <svg viewBox="0 0 56 56">
        <circle cx="28" cy="28" r="20" stroke="currentColor" strokeWidth="1.8" fill="none" />
        <text x="28" y="26" textAnchor="middle" fontFamily="Inter" fontSize="11" fontWeight="900" fill="currentColor">ISO</text>
        <text x="28" y="38" textAnchor="middle" fontSize="8" fontWeight="700" fill="currentColor">20022</text>
      </svg>
    ),
  },
  {
    green: true,
    lbl: 'India-resident data',
    desc: 'sovereign cloud available',
    icon: (
      <svg viewBox="0 0 56 56" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8 C 14 12, 12 16, 14 20 L 16 22 L 14 26 L 16 30 L 13 34 L 18 40 L 22 38 L 26 44 L 30 48 L 34 44 L 38 36 L 44 28 L 42 22 L 38 16 L 32 12 L 28 14 L 22 10 Z" />
        <circle cx="30" cy="28" r="2" fill="currentColor" />
      </svg>
    ),
  },
]

export default function IndiaEcosystemSection() {
  const doubled = [...CARDS, ...CARDS]
  return (
    <section className="sf-eco" id="india">
      <div className="sf-container">
        <div className="sf-section-header sf-reveal" data-sf-reveal>
          <span className="sf-eyebrow green"><span className="sf-pulse" />Built for India</span>
          <h2 className="sf-section-title">Built around <em>India&rsquo;s financial rails.</em></h2>
          <p className="sf-section-lede">
            Preconfigured for RBI posture, PMLA filings and UPI-shaped risk patterns.
            Day-one alignment isn&rsquo;t a six-month implementation project.
          </p>
        </div>
      </div>
      <div className="sf-eco-marquee">
        <div className="sf-eco-marquee-row">
          {doubled.map((c, i) => (
            <div
              key={i}
              className={`sf-eco-card${c.green ? ' sf-green' : ''}`}
              aria-hidden={i >= CARDS.length ? 'true' : undefined}
            >
              <div className="sf-eco-ico">{c.icon}</div>
              <div className="sf-eco-lbl">{c.lbl}</div>
              <div className="sf-eco-desc">{c.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .sf-eco {
          position: relative; background: var(--bg);
          padding: clamp(96px,11vw,150px) 0;
          overflow: hidden;
        }
        .sf-eco::before {
          content: ''; position: absolute; inset: 0;
          background: radial-gradient(60% 40% at 50% 0%,rgba(34,197,94,0.04),transparent 70%);
          pointer-events: none;
        }
        .sf-eco-marquee {
          position: relative; margin-top: 60px;
          display: flex; overflow: hidden;
          mask-image: linear-gradient(to right,transparent,#000 8%,#000 92%,transparent);
          -webkit-mask-image: linear-gradient(to right,transparent,#000 8%,#000 92%,transparent);
        }
        .sf-eco-marquee-row {
          display: flex; gap: 22px; flex-shrink: 0;
          padding: 18px 11px; will-change: transform;
          animation: sfMarquee 40s linear infinite;
        }
        .sf-eco-marquee-row:hover { animation-play-state: paused; }
        @keyframes sfMarquee {
          from { transform: translateX(0); }
          to { transform: translateX(calc(-6 * (240px + 22px))); }
        }
        .sf-eco-card {
          flex-shrink: 0; width: 240px; height: 200px;
          border-radius: var(--radius-lg); background: #fff;
          border: 1px solid var(--line);
          box-shadow: var(--shadow-sm);
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          text-align: center; gap: 14px; padding: 22px;
          transition: all 0.3s var(--ease);
          position: relative; overflow: hidden; cursor: default;
        }
        .sf-eco-card::before {
          content: ''; position: absolute; inset: 0;
          background: linear-gradient(135deg,rgba(14,165,233,0.04),transparent 60%);
          opacity: 0; transition: opacity 0.3s;
        }
        .sf-eco-card.sf-green::before {
          background: linear-gradient(135deg,rgba(34,197,94,0.05),transparent 60%);
        }
        .sf-eco-card:hover {
          border-color: var(--ca-300);
          box-shadow: 0 24px 60px -20px rgba(14,165,233,0.30);
          transform: translateY(-6px) scale(1.02);
        }
        .sf-eco-card.sf-green:hover {
          border-color: var(--sf-300);
          box-shadow: 0 24px 60px -20px rgba(34,197,94,0.30);
        }
        .sf-eco-card:hover::before { opacity: 1; }
        .sf-eco-ico {
          color: var(--ca-600);
          transition: transform 0.3s var(--ease);
        }
        .sf-eco-card.sf-green .sf-eco-ico { color: var(--sf-700); }
        .sf-eco-card:hover .sf-eco-ico { transform: scale(1.15); }
        .sf-eco-ico :global(svg) { width: 50px; height: 50px; }
        .sf-eco-lbl {
          font-size: 14px; font-weight: 600;
          color: var(--text); letter-spacing: -0.01em; line-height: 1.3;
        }
        .sf-eco-desc {
          font-size: 11.5px; color: var(--text-3);
          line-height: 1.5; max-width: 22ch;
          font-family: var(--mono); letter-spacing: 0.02em;
        }
      `}</style>
    </section>
  )
}
